import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    width: 100%;
`;

export const HeaderTitle = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const CloseButton = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;    
`;

export const SelectorContainer = styled(Paper)`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 16px;
  flex: 1;
  padding: 8px;
  margin-top: 16px;
`;

export const BoxesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 400px;
  flex-wrap: wrap;
  gap: 16px;
  flex: 1;
  flex-direction: row;
  padding: 8px;
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    padding-top: 16px;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 8px;
`;
